import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqs = [
  {
    question: "このサービスは無料ですか？",
    answer: "はい、現在は無料でご利用いただけます。",
  },
  {
    question: "どんな商品を探せますか？",
    answer: "家電・ガジェット・日用品など幅広く対応予定です。",
  },
  {
    question: "会員登録は必要ですか？",
    answer: "登録なしでもご利用いただけます。",
  },
];

export default function FaqSection() {
  return (
    <section className="w-full py-20 bg-white">
      <Box className="max-w-4xl mx-auto px-6">
        <Typography
          variant="h5"
          fontWeight="bold"
          mb={4}
          sx={(theme) => ({
            color: theme.palette.primary.main,
            textAlign: "center",
          })}
        >
          よくある質問
        </Typography>

        <Box className="flex flex-col gap-2">
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              disableGutters
              elevation={0}
              sx={{
                backgroundColor: "#f7f8fa",
                "&:before": { display: "none" },
                borderRadius: 0,
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={(theme) => ({
                      color: theme.palette.primary.main,
                    })}
                  />
                }
                sx={{
                  paddingY: 1.5,
                  paddingX: 2,
                  "&:hover": {
                    backgroundColor: "#eef1f6",
                  },
                }}
              >
                <Typography
                  sx={(theme) => ({
                    color: theme.palette.primary.main,
                    fontWeight: 500,
                  })}
                >
                  <span style={{ marginRight: 8 }}>Q</span>
                  {faq.question}
                </Typography>
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  paddingX: 2,
                  paddingBottom: 2,
                  backgroundColor: "#ffffff",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#333",
                    lineHeight: 1.8,
                  }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </section>
  );
}
